export var ETaskType;
(function (ETaskType) {
    ETaskType["PARENT"] = "PARENT";
    ETaskType["CHILD"] = "CHILD";
})(ETaskType || (ETaskType = {}));
export var ETaskFunctionType;
(function (ETaskFunctionType) {
    ETaskFunctionType["NORMAL"] = "NORMAL";
    ETaskFunctionType["OBSERVABLE"] = "OBSERVABLE";
})(ETaskFunctionType || (ETaskFunctionType = {}));
export var ERunningTaskStatus;
(function (ERunningTaskStatus) {
    ERunningTaskStatus["RUNNING"] = "RUNNING";
    ERunningTaskStatus["FINISHED"] = "FINISHED";
    ERunningTaskStatus["TIMED_OUT"] = "TIMED_OUT";
    ERunningTaskStatus["CRASHED"] = "CRASHED";
})(ERunningTaskStatus || (ERunningTaskStatus = {}));
export var ETaskFeedbackType;
(function (ETaskFeedbackType) {
    ETaskFeedbackType["PERCENT"] = "PERCENT";
    ETaskFeedbackType["UNQUANTIFIABLE"] = "UNQUANTIFIABLE";
    ETaskFeedbackType["FRACTION"] = "FRACTION";
})(ETaskFeedbackType || (ETaskFeedbackType = {}));
export var ETaskStatus;
(function (ETaskStatus) {
    ETaskStatus["OKAY"] = "OKAY";
    ETaskStatus["WARNING"] = "WARNING";
    ETaskStatus["ERROR"] = "ERROR";
    ETaskStatus["CRASH"] = "CRASH";
})(ETaskStatus || (ETaskStatus = {}));
export var ETaskProgressAction;
(function (ETaskProgressAction) {
    ETaskProgressAction["DELAY"] = "DELAY";
    ETaskProgressAction["START"] = "START";
    ETaskProgressAction["BUSY"] = "BUSY";
    ETaskProgressAction["END"] = "END";
})(ETaskProgressAction || (ETaskProgressAction = {}));
export var ETaskFunctionEndId;
(function (ETaskFunctionEndId) {
    ETaskFunctionEndId["SUCCESS"] = "SUCCESS";
    ETaskFunctionEndId["ERROR"] = "ERROR";
    ETaskFunctionEndId["THROWN_ERROR"] = "THROWN_ERROR";
    ETaskFunctionEndId["EXTERNAL_API_ERROR"] = "EXTERNAL_API_ERROR";
    ETaskFunctionEndId["WARNING"] = "WARNING";
    ETaskFunctionEndId["NOT_FOUND"] = "NOT_FOUND";
    ETaskFunctionEndId["CONFLICT_FOUND"] = "CONFLICT_FOUND";
    ETaskFunctionEndId["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    ETaskFunctionEndId["TIMED_OUT"] = "TIMED_OUT";
    ETaskFunctionEndId["ILLEGAL_ARGUMENT"] = "ILLEGAL_ARGUMENT";
    ETaskFunctionEndId["LIMIT_REACHED"] = "LIMIT_REACTED";
    ETaskFunctionEndId["UNAUTHORIZED"] = "UNAUTHORIZED";
    ETaskFunctionEndId["FORBIDDEN"] = "FORBIDDEN";
    ETaskFunctionEndId["DATA_VALIDATION_FAILED"] = "DATA_VALIDATION_FAILED";
    ETaskFunctionEndId["REDIRECT"] = "REDIRECT";
})(ETaskFunctionEndId || (ETaskFunctionEndId = {}));
export var EInternalTaskIds;
(function (EInternalTaskIds) {
    EInternalTaskIds["util_run_task_function_on_object"] = "util_run_task_function_on_object";
})(EInternalTaskIds || (EInternalTaskIds = {}));
// export type TTaskFunctionSync<I = {}, OP = any, OE = any> = (
//   ...args: [I, Observer<ITaskProgressUpdate>]
// ) => // options?: I,
// observer?: Observer<ITaskProgressUpdate>
// ITaskFunctionResponse<OP, OE>;
export var EEndLabelSeverity;
(function (EEndLabelSeverity) {
    EEndLabelSeverity[EEndLabelSeverity["error"] = 0] = "error";
    EEndLabelSeverity[EEndLabelSeverity["warning"] = 1] = "warning";
    EEndLabelSeverity[EEndLabelSeverity["info"] = 2] = "info";
})(EEndLabelSeverity || (EEndLabelSeverity = {}));
